import React, { useEffect, useState } from "react";
import "./App.css";
import NavBar from "./components/NavBar";
import Home from "./components/Home";
// import SocialLinks from "./components/SocialLinks";
import About from "./components/About";
import Contact from "./components/Contact";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Experience from "./components/Experience";
// import ParticleTrail from "./components/ParticleTrail";
import CursorGlow from "./components/CursorGlow";

const App = () => {
  const [animatedElements, setAnimatedElements] = useState([]);

  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll(".fade-in");
      const animatedElementsArray = Array.from(elements).filter((element) => {
        const rect = element.getBoundingClientRect();
        const offset = window.innerHeight - rect.height / 2;
        return rect.top < offset;
      });
      setAnimatedElements(animatedElementsArray);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    animatedElements.forEach((element) => {
      element.classList.add("animate");
    });
  }, [animatedElements]);

  return (
    <div className="relative">
      {/* <ParticleTrail /> */}
      <CursorGlow />
      <NavBar />
      <Home />
      <About />
      <Skills />
      <Projects />
      <Experience />
      <Contact />
      {/* <SocialLinks /> */}
    </div>
  );
};

export default App;
